import axios from './biAxios';
import authHeader from "./authentification-header";

const API_URL = "/api/driver/";

const saveAdHoc = (name, phone, transportId) => axios
    .post(`${API_URL}saveadhoc`, { name: name ?? null, phone: phone ?? null, transportId: transportId ?? null }, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));

const updateAdHoc = (id, name, phone, transportId) => axios
    .post(`${API_URL}updateadhoc`, { driverId: id ?? null, name: name ?? null, phone: phone ?? null, transportId: transportId ?? null }, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));

const allActions = {
    saveAdHoc,
    updateAdHoc
};

export default allActions;